import Log from './Log';
import isUndef from 'licia/isUndef';
import perfNow from 'licia/perfNow';
import now from 'licia/now';
import isStr from 'licia/isStr';
import extend from 'licia/extend';
import uniqId from 'licia/uniqId';
import isRegExp from 'licia/isRegExp';
import isFn from 'licia/isFn';
import Stack from 'licia/Stack';
import isEmpty from 'licia/isEmpty';
import contain from 'licia/contain';
import copy from 'licia/copy';
import each from 'licia/each';
import toArr from 'licia/toArr';
import keys from 'licia/keys';
import last from 'licia/last';
import throttle from 'licia/throttle';
import xpath from 'licia/xpath';
import lowerCase from 'licia/lowerCase';
import dateFormat from 'licia/dateFormat';
import isHidden from 'licia/isHidden';
import stripIndent from 'licia/stripIndent';
import ResizeSensor from 'licia/ResizeSensor';
import isNull from 'licia/isNull';
import Component from '../share/Component';
import raf from 'licia/raf';
import trim from 'licia/trim';
import { exportCjs } from '../share/util';
const u = navigator.userAgent;
const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
let id = 0;
export default class Console extends Component {
    constructor(container, options = {}) {
        super(container, { compName: 'console' }, options);
        this.spaceHeight = 0;
        this.topSpaceHeight = 0;
        this.bottomSpaceHeight = 0;
        this.lastScrollTop = 0;
        this.lastTimestamp = 0;
        this.speedToleranceFactor = 100;
        this.maxSpeedTolerance = 2000;
        this.minSpeedTolerance = 100;
        this.logs = [];
        this.displayLogs = [];
        this.timer = {};
        this.counter = {};
        this.asyncList = [];
        this.asyncTimer = null;
        this.isAtBottom = true;
        this.groupStack = new Stack();
        this.selectedLog = null;
        this.onScroll = () => {
            const { scrollHeight, offsetHeight, scrollTop } = this
                .container;
            if (scrollTop <= 0)
                return;
            if (offsetHeight + scrollTop > scrollHeight)
                return;
            let isAtBottom = false;
            if (scrollHeight === offsetHeight) {
                isAtBottom = true;
            }
            else if (Math.abs(scrollHeight - offsetHeight - scrollTop) < 1) {
                isAtBottom = true;
            }
            this.isAtBottom = isAtBottom;
            const lastScrollTop = this.lastScrollTop;
            const lastTimestamp = this.lastTimestamp;
            const timestamp = now();
            const duration = timestamp - lastTimestamp;
            const distance = scrollTop - lastScrollTop;
            const speed = Math.abs(distance / duration);
            let speedTolerance = speed * this.speedToleranceFactor;
            if (duration > 1000) {
                speedTolerance = 1000;
            }
            if (speedTolerance > this.maxSpeedTolerance) {
                speedTolerance = this.maxSpeedTolerance;
            }
            if (speedTolerance < this.minSpeedTolerance) {
                speedTolerance = this.minSpeedTolerance;
            }
            this.lastScrollTop = scrollTop;
            this.lastTimestamp = timestamp;
            let topTolerance = 0;
            let bottomTolerance = 0;
            if (lastScrollTop < scrollTop) {
                topTolerance = this.minSpeedTolerance;
                bottomTolerance = speedTolerance;
            }
            else {
                topTolerance = speedTolerance;
                bottomTolerance = this.minSpeedTolerance;
            }
            if (this.topSpaceHeight < scrollTop - topTolerance &&
                this.topSpaceHeight + this.el.offsetHeight >
                    scrollTop + offsetHeight + bottomTolerance) {
                return;
            }
            this.renderViewport({
                topTolerance: topTolerance * 2,
                bottomTolerance: bottomTolerance * 2,
            });
        };
        this.initTpl();
        this.initOptions(options, {
            maxNum: 0,
            asyncRender: true,
            showHeader: false,
            filter: '',
            level: ['verbose', 'info', 'warning', 'error'],
            accessGetter: false,
            unenumerable: true,
            lazyEvaluation: true,
        });
        this.$el = this.find('.logs');
        this.el = this.$el.get(0);
        this.$fakeEl = this.find('.fake-logs');
        this.fakeEl = this.$fakeEl.get(0);
        this.$space = this.find('.logs-space');
        this.space = this.$space.get(0);
        if (isAndroid) {
            this.speedToleranceFactor = 800;
            this.maxSpeedTolerance = 3000;
            this.minSpeedTolerance = 800;
        }
        this.resizeSensor = new ResizeSensor(container);
        this.renderViewport = throttle((options) => {
            this._renderViewport(options);
        }, 16);
        this.global = {
            copy(value) {
                if (!isStr(value))
                    value = JSON.stringify(value, null, 2);
                copy(value);
            },
            $(selectors) {
                return document.querySelector(selectors);
            },
            $$(selectors) {
                return toArr(document.querySelectorAll(selectors));
            },
            $x(path) {
                return xpath(path);
            },
            clear: () => {
                this.clear();
            },
            dir: (value) => {
                this.dir(value);
            },
            table: (data, columns) => {
                this.table(data, columns);
            },
            keys,
        };
        this.bindEvent();
    }
    setGlobal(name, val) {
        this.global[name] = val;
    }
    destroy() {
        this.$container.off('scroll', this.onScroll);
        this.resizeSensor.destroy();
        super.destroy();
    }
    count(label = 'default') {
        const { counter } = this;
        !isUndef(counter[label]) ? counter[label]++ : (counter[label] = 1);
        this.info(`${label}: ${counter[label]}`);
    }
    countReset(label = 'default') {
        this.counter[label] = 0;
    }
    assert(...args) {
        if (isEmpty(args))
            return;
        const exp = args.shift();
        if (!exp) {
            if (args.length === 0)
                args.unshift('console.assert');
            args.unshift('Assertion failed: ');
            this.insert('error', args);
        }
    }
    log(...args) {
        if (isEmpty(args))
            return;
        this.insert('log', args);
    }
    debug(...args) {
        if (isEmpty(args))
            return;
        this.insert('debug', args);
    }
    dir(obj) {
        if (isUndef(obj))
            return;
        this.insert('dir', [obj]);
    }
    table(...args) {
        if (isEmpty(args))
            return;
        this.insert('table', args);
    }
    time(name = 'default') {
        if (this.timer[name]) {
            return this.insert('warn', [`Timer '${name}' already exists`]);
        }
        this.timer[name] = perfNow();
    }
    timeLog(name = 'default') {
        const startTime = this.timer[name];
        if (!startTime) {
            return this.insert('warn', [`Timer '${name}' does not exist`]);
        }
        this.info(`${name}: ${perfNow() - startTime}ms`);
    }
    timeEnd(name = 'default') {
        this.timeLog(name);
        delete this.timer[name];
    }
    clear(silent = false) {
        this.logs = [];
        this.displayLogs = [];
        this.selectLog(null);
        this.lastLog = undefined;
        this.counter = {};
        this.timer = {};
        this.groupStack = new Stack();
        this.asyncList = [];
        if (this.asyncTimer) {
            clearTimeout(this.asyncTimer);
            this.asyncTimer = null;
        }
        if (silent) {
            this.render();
        }
        else {
            this.insert('log', [
                '%cConsole was cleared',
                'color:#808080;font-style:italic;',
            ]);
        }
    }
    info(...args) {
        if (isEmpty(args))
            return;
        this.insert('info', args);
    }
    error(...args) {
        if (isEmpty(args))
            return;
        this.insert('error', args);
    }
    warn(...args) {
        if (isEmpty(args))
            return;
        this.insert('warn', args);
    }
    group(...args) {
        this.insert({
            type: 'group',
            args,
            ignoreFilter: true,
        });
    }
    groupCollapsed(...args) {
        this.insert({
            type: 'groupCollapsed',
            args,
            ignoreFilter: true,
        });
    }
    groupEnd() {
        this.insert('groupEnd');
    }
    evaluate(code) {
        this.insert({
            type: 'input',
            args: [code],
            ignoreFilter: true,
        });
        try {
            this.output(this.evalJs(code));
        }
        catch (e) {
            this.insert({
                type: 'error',
                ignoreFilter: true,
                args: [e],
            });
        }
    }
    html(...args) {
        this.insert('html', args);
    }
    toggleGroup(log) {
        const { targetGroup } = log;
        targetGroup.collapsed
            ? this.openGroup(log)
            : this.collapseGroup(log);
    }
    output(val) {
        this.insert({
            type: 'output',
            args: [val],
            ignoreFilter: true,
        });
    }
    render() {
        const { logs, selectedLog } = this;
        this.$el.html('');
        this.isAtBottom = true;
        this.updateBottomSpace(0);
        this.updateTopSpace(0);
        this.displayLogs = [];
        for (let i = 0, len = logs.length; i < len; i++) {
            this.attachLog(logs[i]);
        }
        if (selectedLog) {
            if (!contain(this.displayLogs, selectedLog)) {
                this.selectLog(null);
            }
        }
    }
    insert(type, args) {
        const { showHeader, asyncRender } = this.options;
        let header;
        if (showHeader) {
            header = {
                time: getCurTime(),
                from: getFrom(),
            };
        }
        if (asyncRender) {
            return this.insertAsync(type, args, header);
        }
        this.insertSync(type, args, header);
    }
    insertAsync(type, args, header) {
        this.asyncList.push([type, args, header]);
        this.handleAsyncList();
    }
    insertSync(type, args, header) {
        const { logs, groupStack } = this;
        const { maxNum, accessGetter, unenumerable, lazyEvaluation } = this.options;
        let options;
        if (isStr(type)) {
            options = {
                type: type,
                args: args,
                header,
            };
        }
        else {
            options = type;
        }
        if (options.type === 'groupEnd') {
            const lastLog = this.lastLog;
            lastLog.groupEnd();
            this.groupStack.pop();
            return;
        }
        if (groupStack.size > 0) {
            options.group = groupStack.peek();
        }
        extend(options, {
            id: ++id,
            accessGetter,
            unenumerable,
            lazyEvaluation,
        });
        if (options.type === 'group' || options.type === 'groupCollapsed') {
            const group = {
                id: uniqId('group'),
                collapsed: false,
                parent: groupStack.peek(),
                indentLevel: groupStack.size + 1,
            };
            if (options.type === 'groupCollapsed')
                group.collapsed = true;
            options.targetGroup = group;
            groupStack.push(group);
        }
        let log = new Log(this, options);
        log.on('updateHeight', () => {
            this.isAtBottom = false;
            this.renderViewport();
        });
        const lastLog = this.lastLog;
        if (lastLog &&
            !contain(['html', 'group', 'groupCollapsed'], log.type) &&
            lastLog.type === log.type &&
            log.isSimple() &&
            lastLog.text() === log.text()) {
            lastLog.addCount();
            if (log.header)
                lastLog.updateTime(log.header.time);
            log = lastLog;
            this.detachLog(lastLog);
        }
        else {
            logs.push(log);
            this.lastLog = log;
        }
        if (maxNum !== 0 && logs.length > maxNum) {
            const firstLog = logs[0];
            this.detachLog(firstLog);
            logs.shift();
        }
        this.attachLog(log);
        this.emit('insert', log);
    }
    updateTopSpace(height) {
        this.topSpaceHeight = height;
        this.el.style.top = height + 'px';
    }
    updateBottomSpace(height) {
        this.bottomSpaceHeight = height;
    }
    updateSpace(height) {
        if (this.spaceHeight === height)
            return;
        this.spaceHeight = height;
        this.space.style.height = height + 'px';
    }
    detachLog(log) {
        const { displayLogs } = this;
        const idx = displayLogs.indexOf(log);
        if (idx > -1) {
            displayLogs.splice(idx, 1);
            this.renderViewport();
        }
    }
    attachLog(log) {
        if (!this.filterLog(log) || log.collapsed)
            return;
        const { displayLogs } = this;
        if (displayLogs.length === 0) {
            displayLogs.push(log);
            this.renderViewport();
            return;
        }
        const lastDisplayLog = last(displayLogs);
        if (log.id > lastDisplayLog.id) {
            displayLogs.push(log);
            this.renderViewport();
            return;
        }
        let startIdx = 0;
        let endIdx = displayLogs.length - 1;
        let middleLog;
        let middleIdx = 0;
        while (startIdx <= endIdx) {
            middleIdx = startIdx + Math.floor((endIdx - startIdx) / 2);
            middleLog = displayLogs[middleIdx];
            if (middleLog.id === log.id) {
                return;
            }
            if (middleLog.id < log.id) {
                startIdx = middleIdx + 1;
            }
            else {
                endIdx = middleIdx - 1;
            }
        }
        if (middleLog.id < log.id) {
            displayLogs.splice(middleIdx + 1, 0, log);
        }
        else {
            displayLogs.splice(middleIdx, 0, log);
        }
        this.renderViewport();
    }
    handleAsyncList(timeout = 20) {
        const asyncList = this.asyncList;
        if (this.asyncTimer)
            return;
        this.asyncTimer = setTimeout(() => {
            this.asyncTimer = null;
            let done = false;
            const len = asyncList.length;
            let timeout, num;
            if (len < 1000) {
                num = 200;
                timeout = 400;
            }
            else if (len < 5000) {
                num = 500;
                timeout = 800;
            }
            else if (len < 10000) {
                num = 800;
                timeout = 1000;
            }
            else if (len < 25000) {
                num = 1000;
                timeout = 1200;
            }
            else if (len < 50000) {
                num = 1500;
                timeout = 1500;
            }
            else {
                num = 2000;
                timeout = 2500;
            }
            if (num > len) {
                num = len;
                done = true;
            }
            for (let i = 0; i < num; i++) {
                const [type, args, header] = asyncList.shift();
                this.insertSync(type, args, header);
            }
            if (!done) {
                raf(() => this.handleAsyncList(timeout));
            }
        }, timeout);
    }
    injectGlobal() {
        each(this.global, (val, name) => {
            if (window[name])
                return;
            window[name] = val;
        });
    }
    clearGlobal() {
        each(this.global, (val, name) => {
            if (window[name] && window[name] === val) {
                delete window[name];
            }
        });
    }
    evalJs(jsInput) {
        let ret;
        this.injectGlobal();
        try {
            ret = eval.call(window, `(${jsInput})`);
        }
        catch (e) {
            ret = eval.call(window, jsInput);
        }
        this.setGlobal('$_', ret);
        this.clearGlobal();
        return ret;
    }
    filterLog(log) {
        const { level } = this.options;
        let { filter } = this.options;
        if (log.ignoreFilter) {
            return true;
        }
        if (!contain(level, log.level)) {
            return false;
        }
        if (filter) {
            if (isFn(filter)) {
                return filter(log);
            }
            else if (isRegExp(filter)) {
                return filter.test(lowerCase(log.text()));
            }
            else if (isStr(filter)) {
                filter = trim(filter);
                if (filter) {
                    return contain(lowerCase(log.text()), lowerCase(filter));
                }
            }
        }
        return true;
    }
    collapseGroup(log) {
        const { targetGroup } = log;
        targetGroup.collapsed = true;
        log.updateIcon('caret-right');
        this.updateGroup(log);
    }
    openGroup(log) {
        const { targetGroup } = log;
        targetGroup.collapsed = false;
        log.updateIcon('caret-down');
        this.updateGroup(log);
    }
    updateGroup(log) {
        const { targetGroup } = log;
        const { logs } = this;
        const len = logs.length;
        let i = logs.indexOf(log) + 1;
        while (i < len) {
            const log = logs[i];
            if (!log.checkGroup() && log.group === targetGroup) {
                break;
            }
            log.collapsed ? this.detachLog(log) : this.attachLog(log);
            i++;
        }
    }
    selectLog(log) {
        if (this.selectedLog) {
            this.selectedLog.deselect();
            this.selectedLog = null;
        }
        if (!isNull(log)) {
            this.selectedLog = log;
            this.selectedLog?.select();
            this.emit('select', log);
        }
        else {
            this.emit('deselect');
        }
    }
    bindEvent() {
        const { $el, c } = this;
        this.resizeSensor.addListener(this.renderViewport);
        const self = this;
        $el.on('click', c('.log-container'), function () {
            self.selectLog(this.log);
        });
        this.on('changeOption', (name, val) => {
            const { logs } = this;
            switch (name) {
                case 'maxNum':
                    if (val > 0 && logs.length > val) {
                        this.logs = logs.slice(logs.length - val);
                        this.render();
                    }
                    break;
                case 'filter':
                    this.render();
                    break;
                case 'level':
                    this.options.level = toArr(val);
                    this.render();
                    break;
            }
        });
        this.$container.on('scroll', this.onScroll);
    }
    _renderViewport({ topTolerance = 500, bottomTolerance = 500 } = {}) {
        const { el, container, space } = this;
        if (isHidden(container))
            return;
        const { scrollTop, offsetHeight } = container;
        const containerWidth = space.getBoundingClientRect().width;
        const top = scrollTop - topTolerance;
        const bottom = scrollTop + offsetHeight + bottomTolerance;
        const { displayLogs } = this;
        let topSpaceHeight = 0;
        let bottomSpaceHeight = 0;
        let currentHeight = 0;
        const len = displayLogs.length;
        const { fakeEl } = this;
        const fakeFrag = document.createDocumentFragment();
        const logs = [];
        for (let i = 0; i < len; i++) {
            const log = displayLogs[i];
            const { width, height } = log;
            if (height === 0 || width !== containerWidth) {
                fakeFrag.appendChild(log.container);
                logs.push(log);
            }
        }
        if (logs.length > 0) {
            fakeEl.appendChild(fakeFrag);
            for (let i = 0, len = logs.length; i < len; i++) {
                logs[i].updateSize();
            }
            fakeEl.textContent = '';
        }
        const frag = document.createDocumentFragment();
        for (let i = 0; i < len; i++) {
            const log = displayLogs[i];
            const { container, height } = log;
            if (currentHeight > bottom) {
                bottomSpaceHeight += height;
            }
            else if (currentHeight + height > top) {
                frag.appendChild(container);
            }
            else if (currentHeight < top) {
                topSpaceHeight += height;
            }
            currentHeight += height;
        }
        this.updateSpace(currentHeight);
        this.updateTopSpace(topSpaceHeight);
        this.updateBottomSpace(bottomSpaceHeight);
        while (el.firstChild) {
            if (el.lastChild) {
                el.removeChild(el.lastChild);
            }
        }
        el.appendChild(frag);
        const { scrollHeight } = container;
        if (this.isAtBottom && scrollTop <= scrollHeight - offsetHeight) {
            container.scrollTop = 10000000;
        }
    }
    initTpl() {
        this.$container.html(this.c(stripIndent `
      <div class="logs-space">
        <div class="fake-logs"></div>
        <div class="logs"></div>
      </div>
    `));
    }
}
const getCurTime = () => dateFormat('HH:MM:ss ');
function getFrom() {
    const e = new Error();
    let ret = '';
    const lines = e.stack ? e.stack.split('\n') : '';
    for (let i = 0, len = lines.length; i < len; i++) {
        ret = lines[i];
        if (ret.indexOf('winConsole') > -1 && i < len - 1) {
            ret = lines[i + 1];
            break;
        }
    }
    return ret;
}
if (typeof module !== 'undefined') {
    exportCjs(module, Console);
}
